import { EvtHeader } from "components/header";
import React from "react";
import CountryForm from "../form";

const CreateCountry = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Country" />
      <div className="p-6 max-w-2xl">
        <CountryForm />
      </div>
    </div>
  );
};

export default CreateCountry;
